<template>
  <div class="notification">
    <notifications position="top right" classes="alert" :duration="duration"
      :speed="500" :max="max" :ignoreDuplicates="true" animation-name="appear"
      animation-type="css"/>
  </div>
</template>
<script>
export default {
  name: 'Notif',
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
    max: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/notif.vue